// eslint-disable-next-line @typescript-eslint/no-unused-vars
import "./styles/index.scss";
import { AppRouter } from "./providers/router";
import { useSentry } from "../shared/lib/hooks/useSentry";
import { useIdentifySessionByEmail } from "../features/analytics";
import { useSetAtom } from "jotai";
import { screenWidthListenerAtom } from "../atoms/screenWidth/screenWidth";
import { useEffect } from "react";

export function App() {
  useSentry();
  useIdentifySessionByEmail();

  const initializeResizeListener = useSetAtom(screenWidthListenerAtom);
  useEffect(() => {
    initializeResizeListener();
  }, [initializeResizeListener]);

  return <AppRouter />;
}

export default App;
